import { Component, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { Drawer, DrawerRef } from '../../../drawer.service';

@Component({
  selector: 'uex-drawer-header',
  templateUrl: './header.component.html',
  host: {
    class: 'uex-drawer-header modal-header'
  }
})
export class DrawerHeaderComponent implements AfterViewInit, OnDestroy {
  @Input('alignItems') public alignItems = 'start';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  @Input('drawer')
  private set __drawer(drawer: Drawer) {
    this._drawer = drawer;
  }

  constructor(
    private _drawerRef: DrawerRef,
    public elementRef: ElementRef
  ) { }

  private _drawer: Drawer;
  private _index: number;

  public ngAfterViewInit() {
    if (this._drawerRef.drawer) { this._drawer = this._drawerRef.drawer; }
    this._index = this._drawer.addHeader(this);
  }

  public ngOnDestroy() {
    this._drawer.removeHeader(this._index);
  }
}
